import { InitializeAssignUserPlacementRequestSchema, InitializeAssignUserPlacementResponseSchema } from './initialize-assign-user-placement.schema';
/**
 * Initialize Assign User Placement Contract
 * PATCH /api/v2/initialize/users/:id/placement
 * Assigns department (and optionally role) to an existing internal user
 * during the setup wizard without touching identity fields
 */ export const initializeAssignUserPlacementContract = {
    method: 'PATCH',
    path: '/api/v2/initialize/users/:id/placement',
    requestSchema: InitializeAssignUserPlacementRequestSchema,
    responseSchema: InitializeAssignUserPlacementResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - user or department not found, user not internal, setup already completed, or invalid input',
            401: 'Unauthorized - user not authenticated'
        }
    },
    description: 'Places an existing internal user into a department (with optional role) during initial setup'
};

//# sourceMappingURL=initialize-assign-user-placement.contract.js.map